import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useState } from 'react'

export const UseQueryProvider = (p: { children: React.ReactNode }) => {
  const [queryClient] = useState(() => new QueryClient())

  return (
    <QueryClientProvider client={queryClient}>{p.children}</QueryClientProvider>
  )
}
